module.exports = __webpack_public_path__ + "static/18-thumb-87eaebe29f14ed02c80aa65ff36bdb28.jpg";